import {
  GET_COMPLAINS,
  GET_COMPLAINS_SUCCESS,
  GET_COMPLAINS_ERROR,
  GET_COMPLAIN,
  GET_COMPLAIN_SUCCESS,
  GET_COMPLAIN_ERROR,
  SEND_COMPLAIN_REPLY,
  SEND_COMPLAIN_REPLY_SUCCESS,
  SEND_COMPLAIN_REPLY_ERROR,
  TOGGLE_NOTIFICATION_REPLY_MODAL,
} from "./actionTypes";

export const getComplains = (request) => {
  return {
    type: GET_COMPLAINS,
    payload: { request },
  };
};

export const getComplainsSuccess = (complains) => {
  return {
    type: GET_COMPLAINS_SUCCESS,
    payload: complains,
  };
};

export const getComplainsError = (message) => {
  return {
    type: GET_COMPLAINS_ERROR,
    payload: message,
  };
};

export const getComplain = (id) => {
  return {
    type: GET_COMPLAIN,
    payload: { id },
  };
};

export const getComplainSuccess = (complain) => {
  return {
    type: GET_COMPLAIN_SUCCESS,
    payload: complain,
  };
};

export const getComplainError = (message) => {
  return {
    type: GET_COMPLAIN_ERROR,
    payload: message,
  };
};

export const sendReplyToComplain = (data) => {
  return {
    type: SEND_COMPLAIN_REPLY,
    payload: data,
  };
};

export const sendReplyToComplainSuccess = () => {
  return {
    type: SEND_COMPLAIN_REPLY_SUCCESS,
  };
};

export const sendReplyToComplainError = (error) => {
  return {
    type: SEND_COMPLAIN_REPLY_ERROR,
    payload: error,
  };
};

export const toggleComplainReplyModal = () => {
  return {
    type: TOGGLE_NOTIFICATION_REPLY_MODAL,
  };
};
